import React from 'react';
import { MultiBrowserComponentView } from './browser-react';
import { DbSource, makeNamedDbSource } from './sql-js-api';
import { BrowserInstance } from './browser-instance';
import { Named } from './util';

function BrowserPage() {

    const fileSources: Named<DbSource>[] = [];
    const instances: BrowserInstance[] = [];

    const addUrl = (url: string) => {
        fileSources.push(makeNamedDbSource(url));
    }

    const addAndOpenUrl = (url: string) => {
        const namedDbSource = makeNamedDbSource(url);
        const newInstance = new BrowserInstance(namedDbSource.name, namedDbSource);

        fileSources.push(namedDbSource);
        instances.push(newInstance);
    }

    addAndOpenUrl('./res/games/island-en/SQL_Island_en.sql');
    addUrl('./res/games/island/SQL_Island.sql');
    addUrl('./res/dbs/fahrschule.sql');
    addUrl('./res/dbs/angproj.sql');
    addUrl('./res/dbs/cafe.sql');

    // addUrl('./res/dbs/eisdiele.sql');
    // addUrl('./res/dbs/onlineshop.sql');
    // addUrl('./res/dbs/pizzeria-mit-redundanz.sql');
    // addUrl('./res/games/island/SQL_Island.sql');
    // addUrl('./res/games/island-en/SQL_Island-en.sql');

    // old stuff
    //addUrl('./res/games/baufirma/baufirma.sql');
    //addUrl('./res/dbs/cafe-sqlite.db');
    //addUrl('./res/dbs/obst-gemuese.sql');
    //addUrl('./res/games/jack-frost/jack-frost.sql');
    //addUrl('./res/games/ozean/ozean.sql');
    //addUrl('./res/games/sql-jungle/sql-jungle.sql');
    
    return (
        <div className="p-4">
            <div className='eskuel'>
                <div className='app-browser'>
                    <MultiBrowserComponentView initialInstances={instances} fileSources={fileSources} />
                </div>
            </div>
        </div>
    );
  }

export default BrowserPage;
  
